export enum AdjustmentSign {
  CREDIT = <any>'CREDIT',
  DEBIT = <any>'DEBIT'
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/adjustment-sign.enum.ts